
// targets keys: heading, content, image
const targets = getTargets();
let data = {};
let filtered = new Array;

function getTargets() {
	const targets = {
		container: document.querySelector(".ca-fortune__content"),
		heading: document.querySelector(".ca-fortune__heading"),
		content: document.querySelector(".ca-fortune__body"),
		select: document.querySelector(".resources__select"),
		resources: document.querySelector(".resources__wrapper"),
		nav: document.querySelector(".flower")
	};
	return targets;
}

async function getUiContent() {
	const ui_response = await fetch('/site/data/cafortune.ui.php');
	const ui_json = await ui_response.json();
	assignEvents(ui_json.petals);
	const resources_response = await fetch('/site/data/data.resources.php');
	data = await resources_response.json();
}

function assignEvents(petals) {
	petals.forEach((content) => {
		// svg hit area to be clicked
		const petal = targets.nav.querySelector("#" + content.id);
		if (petal !== null) {
			petal.onclick = () => petalClick(petal, content);
			petal.onmouseover = () => targets.nav.setAttribute("title", content.heading);
		}
	});
}

function filterResources(content) {
	if (!data.resources) return;
	container = structuredClone(data);
	if (!filtered[content.id]) {
		filtered[content.id] = container.resources.filter(cat => {
			cat.items = cat.items.filter(item => item.brand.name == content.brand);
			if (cat.items.length) return cat;
		});
	}
	createSelect(filtered[content.id]);
}

function petalClick(petal, content) {
	petalClickReset();
	filterResources(content);
	petal.classList.add("hover"); // to persist the hover state
	// change the content
	targets.heading.innerHTML = content.heading;
	targets.content.innerHTML = content.content;
	if (content.read_more) read_more();
	// targets.select.innerHTML = createSelect(content);
	targets.container.append(backToTop());
	// scroll animate
	scroll_to(".ca-fortune__content")
	// targets.container.scrollIntoView();
}

function petalClickReset() {
	removeHoverClasses(); // nuke all the hover states
	targets.select.innerHTML = null;
	targets.resources.innerHTML = null;
}
function createSelect(content) {
	// empty the div in preparation of a new select or no select
	targets.select.innerHTML = null;
	if (!content.length) return null; // array is empty
	const select = document.createElement("select");
	select.innerHTML = "<option value=''>Resources</option>";
	select.content = [];
	content.forEach(category => {
		const option = document.createElement("option");
		option.value = category.name;
		option.textContent = category.title;
		select.content[category.name] = category.items;
		select.append(option);
	});
	select.onchange = selectChange;
	targets.select.append(select);
}
function selectChange(event) {
	const id = event.target.value;
	const content = event.target.content;
	writeThumbnails(content[id]);
}
function writeThumbnails(array) {
	// clear it out
	targets.resources.innerHTML = null;
	array.forEach(item => {
		const template = `
			<div class="cafortune__tile">
				<a href="${item.url}" target="_blank" title="${item.title}" class="cafortune__link">
					<div class="cafortune__thumb">
						<img src="${item.thumb}" alt="" class="cafortune__image">
						<div class="cafortune__overlay">
							${item.title}
						</div>
					</div>
				</a>
			</div>
		`;
		const temporary = document.createElement("div");
		temporary.innerHTML = template.trim();
		targets.resources.appendChild(temporary.firstChild);
	});
	scroll_to(".resources__select")
	// targets.select.scrollIntoView();
}

function removeHoverClasses() {
	const active = targets.nav.querySelectorAll(".hover");
	active.forEach(ele => ele.classList.remove("hover"));
}

function backToTop() {
	const btt = document.querySelector(".btt");
	if (btt) btt.remove();

	// back to top base element
	const container = document.createElement("div");
	container.classList.add("btt");
	// the visible link
	const link = document.createElement("a");
	link.innerHTML = "[ <strong>Back to top</strong> ]";
	link.onclick = () => scroll_to("#main");
	// combine and return
	container.append(link);
	return container;
}

function scroll_to(selector) {
	// e.preventDefault();
	const target = document.querySelector(selector);
	const targetY = target.offsetTop;
	const headerY = document.querySelector(".ca-fortune__header").scrollHeight;
	const vertical = targetY - headerY;
	// const $header = $(".ca-fortune__header")[0];
	// const $target = $($(this).attr("href"));
	// const vertical = $target.offset().top - $header.height();

	window.scrollTo({
		top: vertical,
		left: 0,
		behavior: "smooth"
	});
}


function read_more() {

	const $read_more = $(".read_more");
	const open_class = "is_open";

	$read_more.each(function () {
		let $wrap = $("<div class='read_more__wrap' />");
		let $wrappble = $(this).children().not(":first-child");
		if ($wrappble.length) {
			$wrappble.wrapAll($wrap);
			// read more button
			let $read_more_button = $("<a href='#' class='read_more__button'>Read More</a>")
			$read_more_button.on("click", function (e) {
				e.preventDefault();
				$(this).prev().addClass(open_class);
				$(this).remove();
				setTimeout(() => scroll_to(".read_more__wrap"), 100);
			});
			$(this).append($read_more_button);
		}
	});
}

export function init() {
	if (targets.container) {
		getUiContent();
	}
}
